import { useState, useEffect } from 'react';
import * as React from 'react';
// tools and component for date picker
import dayjs from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


//MUI
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';

//import fr from 'dayjs/locale/fr';
const fr = require('dayjs/locale/fr')
dayjs.locale(fr);

console.log(fr);

const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)


function BlocStockSemaine({ article, dataSet, dateRef }) {
    let creneauxSemaine = [];
    for (let i = 0; i < 84; i++) { creneauxSemaine.push(i) }
    //console.log(dataSet)
    // Dataset is list of contrat for this week (modified 1/1/24)


    const [open, setOpen] = useState(false);
    const [infoHeure, setInfoHeure] = useState("");
    const [infoStock, setInfoStock] = useState("");
    const [infoRatio, setInfoRatio] = useState("");


    function handleOpen(index) {
        let qte = dataSet[index] || 0;


        let jour = Math.floor(index / 12);
        let heure = (index - jour * 12) + 9;
        setInfoHeure("Le " + dateRef.weekday(jour).format("DD/MM") + " à " + heure + " heures");
        setInfoStock(qte + " articles loués / " + article.stock);
        setInfoRatio(Math.round(qte / article.stock * 100) + "% d'occupation");

        setOpen(true);
    };

    const handleClose = () => setOpen(false);



    function getStyle(index) {

        let qte = dataSet[index] || 0;
        let ratio = Math.round(qte / article.stock * 100);

        let jour = Math.floor(index / 12);
        let heure = (index - jour * 12);

        return (
            {
                width: `${(Math.round(800 / 7 / 12)) - 2}px`,
                height: `${Math.round(ratio) < 100 ? 100 - Math.round(ratio) : 2}px`, // %age en pixel parceque la ligne mesure 100px de haut (manager.scss ligne 510, classe .ligne-stock)
                transform: `translateX(${(800 / 7) * jour + (800 / 7 / 12) * heure}px)`
            }

        )
    }

    function getClasse(index) {
        let qte = dataSet[index] || 0;
        let ratio = Math.round(qte / article.stock * 100);

        let laClasse = "bloc-stock";

        if (ratio >= 100) { laClasse += " bloc-100"; }
        if (ratio >= 80 && ratio < 100) { laClasse += " bloc-90"; }
        if (ratio >= 50 && ratio < 80) { laClasse += " bloc-80"; }
        if (ratio < 50) { laClasse += " bloc-50"; }

        return laClasse;


    }

    //console.log(dataSet);

    /*  */

    return (

        <div className="ligne-stock">
            <div className={"ligne-stock-nom "}>
                <p>{article.type} ({article.stock})</p>
            </div>
            <div className="ligne-stock-semaine">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>

                {creneauxSemaine.map((index) => (
                    <div key={index} style={getStyle(index)} className={getClasse(index)} onClick={_ => handleOpen(index)}>
                        <div className="bloc-contrat-infos"></div>
                    </div>
                ))}


            </div>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <div className="modal-contrat">
                    <div className="modal-contrat-top">
                        <span className="modal-contrat-top-bt-close" onClick={_ => setOpen(false)}><CloseIcon /></span>

                    </div>
                    <div className="modal-contrat-middle">
                        <div className="modal-contrat-middle-stock">
                            <h3>{article.type}</h3>
                            <p>{infoHeure}</p>
                            <p>{infoStock}</p>
                            <p>{infoRatio}</p>
                        </div>
                    </div>

                </div>
            </Modal>
        </div>

    );
}

export default BlocStockSemaine